<template>
  <div class="Container">
    <img v-if="imgSrc" :src="imgSrc" />
    <input type="file" ref="upload" accept="image/*" style="display: none" @change="onImageSubmit" />
    <div v-if="isAdmin" class="Overlay" @click="onClick">
      <p class="Text">Byt ut bild</p>
    </div>
  </div>
</template>

<script>
import { getFile, uploadFile } from '@/firebase';
import Cookies from "js-cookie";

export default {
  data() {
    return {
      imgSrc: null,
      isAdmin: Cookies.get("user") ? true : false,
    };
  },
  props: {
    imageId: {
      type: String,
      required: true,
    },
  },
  async created() {
    this.imgSrc = await getFile(`images/${this.imageId}`);
  },
  methods: {
    onClick() {
      this.$refs.upload.click();
    },
    async onImageSubmit(event) {
      const imageId = event.target.files[0].name;
      await uploadFile(event.target.files[0]).then();
      if (this.$parent.updateImageId) {
        this.$parent.updateImageId(imageId);
      }
      this.imgSrc = await getFile(`images/${imageId}`);
      this.$notify({ text: 'Bild uppdaterad', type: 'success' });
    },
  },
};
</script>

<style scoped>
.Container {
  position: relative;
}
.Container img {
  position: relative;
  display: block;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.Overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: black;
}

.Container:hover .Overlay {
  opacity: 0.6;
}
.Text {
  color: white;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>
